import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Page from '../../components/Page';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import Googlesheets from './googlesheets';
import Googlecontacts from './googlecontacts';
import Dialogflow from './dialogflow';

export default (props) => {
	return (
		<Page title={'Integrations'} icon={<IntegrationInstructionsIcon sx={{ mr: 0.5 }} size="medium" />}>
			<Page.Wrap>
				<Switch>
					{/* <Route path="/settings/company" component={Company} /> */}
					<Route path="/integrations" exact component={Googlesheets} />
					<Route path="/integrations/sheets" component={Googlesheets} />
					<Route path="/integrations/contacts" component={Googlecontacts} />
					<Route path="/integrations/dialogflow" component={Dialogflow} />
				</Switch>
			</Page.Wrap>
		</Page>
	);
};
